export const required = value => value ? undefined : 'required';
export const minLength = length => value => {
  return value.length >= length ? undefined : 'minLength';
};
export const notEmptyString = value => {
  return minLength(1)(value.trim()) ? 'notEmpty' : undefined;
};
export const composeValidators = (...validators) => value => validators.reduce((error, validator) => error || validator(value), undefined);